import { FC, PropsWithChildren } from 'react'

import { AppProvider } from './AppProvider'
import { LayoutContext, useLayoutProvider } from './LayoutProvider'
import { ReactQueryProvider } from './ReactQueryProvider'
import { RootProvider } from './RootProvider'

export const Providers: FC<PropsWithChildren> = props => {
  const layout = useLayoutProvider()

  return (
    <LayoutContext.Provider value={layout}>
      <RootProvider mode={layout.themeMode}>
        <ReactQueryProvider>
          <AppProvider>{props.children}</AppProvider>
        </ReactQueryProvider>
      </RootProvider>
    </LayoutContext.Provider>
  )
}
